import { AutogenLayoutlayout_digroup } from "./autogen/AutogenLayoutlayout_digroup";
import { DropdownItem, DataDisplayEvent } from "@mcleod/components";

export class layout_digroup extends AutogenLayoutlayout_digroup {

    private timer: any;

    override onLoad() {
        //console.log(this);
        const items: DropdownItem[] = [];
        //items.push({ caption: "Desktop", value: "D" });
        //items.push({ caption: "Mobile", value: "M" });
        //items.push({ caption: "API", value: "A" });
        items.push(new DropdownItem("D", "Desktop"));
        items.push(new DropdownItem("M", "Mobile"));
        items.push(new DropdownItem("A", "API"));
        this.textboxDigroupType.items = items;

        clearInterval(this.timer);
        this.timer = setInterval(() => this.GetGroupID(), 250);
    }

    async GetGroupID()
    {
        clearInterval(this.timer);
        this.timer = null;
        let gid=0, pgid=0;
        if( this.sourceDigroup.mode == "add" )
        {   //Adding a new record
            await this.sourceDigroup2.search( { digroup_gid: ">0" } );
            for( let i=0; i < this.sourceDigroup2.rowCount; i++ )
            {
                this.sourceDigroup2.rowIndex = i;
                gid = this.sourceDigroup2.activeRow.data.digroup_gid;
                if( gid > pgid )
                    pgid = gid;
            }
            if( pgid > 0 )
            {
                pgid += 1;
                this.textboxDigroupGid.text = pgid.toString();
            }
        }
    }

/** This is an event handler for the onDataDisplay event of textboxDigroupType. */
    textboxDigroupTypeOnDataDisplay(event: DataDisplayEvent) {
        if( this.sourceDigroup.mode == "update" && this.textboxDigroupType.text.length <= 0 )
            this.textboxDigroupType.selectedItem = this.textboxDigroupType.items[0];    //default to Desktop Type
        }
}
